module.exports = __webpack_public_path__ + "media/images/front/banner_kyusyu_dental_show_2-230c21de815704fe820eb92c0e375471.png";